import { Cart } from '@/types/storefront';
import { create } from 'zustand';

export const useCartStore = create<{
  cart?: Cart;
  isOpen: boolean;
  toggleCart: () => void;
  expires: number;
  tick: () => void;
}>((set) => ({
  cart: undefined,
  isOpen: false,
  toggleCart: () => {
    set((state) => ({ isOpen: !state.isOpen }));
  },
  expires: 0,
  tick: () => {
    set((state) => ({ expires: state.expires > 0 ? state.expires - 1 : 0 }));
  }
}));
